import { HospitalModel } from './hospital.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../../utils/common.constants';

@Injectable()
export class HospitalService {
  constructor(private http: HttpClient) {
  }

  private handleError(error: any) {
    return Observable.throw(error || 'Server error');
  }

  saveHospital(hospital) : Observable<any>{
   return this.http.post(CommonConstants.SAVE_HOSPITAL, hospital).
   pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getHospitalsById(hospId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/hospital/' + hospId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getHospitals(startIndex): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/hospitals'+ '?start=' + startIndex + '&size='
    + CommonConstants.PAGINATION_SIZE).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  searchHospitals(hospitals:any, startIndex) {
      return this.http.post(CommonConstants.env +'api/partner/hospitals/search' + '?start=' + startIndex + '&size='
      + CommonConstants.PAGINATION_SIZE, hospitals)
  }

  errorHandler(error: any): void {
    throwError(error);
  };
}
